import { render } from "./ModalIdle.vue?vue&type=template&id=b36de200"
import script from "./ModalIdle.vue?vue&type=script&lang=js"
export * from "./ModalIdle.vue?vue&type=script&lang=js"

import "./ModalIdle.vue?vue&type=style&index=0&id=b36de200&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__